// extracted by mini-css-extract-plugin
module.exports = {"model__desc":"PrimitiveModel_model__desc__3jhir","model__desc__mini":"PrimitiveModel_model__desc__mini__nKbYX","model__properties":"PrimitiveModel_model__properties__1SlkG"};